export default __webpack_public_path__ + "static/media/students.d52e560d.svg";